.switchContainer {
  gap: 1rem;
}

.switchButton {
  width: 48px;
  height: 24px;
  background-color: #525252; /* Using static HEX here instead of var since it needs to be the same in both light and dark */
  border-radius: 30px;
  border: none;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s;
}

.switchButton:hover {
  background-color: var(--static-text-weak);
}

.switchButton.on {
  background-color: var(--color-primary);
}

.switchNub {
  width: 20px;
  height: 20px;
  background-color: #F2F2F2; /* Using static HEX here instead of var since it needs to be the same in both light and dark */
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: left 0.3s;
}

.switchNub.on {
  left: 25px;
}

.text {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 0.25rem;
}

.disabled {
  opacity: 0.5;
}

.disabledCursor {
  cursor: not-allowed;
}